export class CreateCloudEnvironmentRequest {
    accountId?: string;
    description?: string;
    isProduction?: boolean;
    name?: string;
    schemaName?: string;
    version?: string;
    deploymentType?: string;
}